import Axios from "@app/api/axios";
import { PERMISSIONS } from "@utils/constant";
const createPermissionsService = (payload) => {
  return Axios.post(PERMISSIONS, payload)
};
export default createPermissionsService;